export default __webpack_public_path__ + "static/media/beauty_front.4c1268ba.png";